import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { onValue, ref } from "firebase/database";
import { database } from "../firebase/firebaseConfig";
import { useLoading } from "../contexts/LoadingContext";
import Swal from "sweetalert2";
import GreetingCard from "./GreetingCard";
import "./LandingPage.css";
import Footer from "./Footer";
import DoctorListComponent from "./doctor-list-component";

const LandingPage = () => {
  const [doctors, setDoctors] = useState([]);
  const [isSession, setSession] = useState(null);
  const { isLoading, setIsLoading } = useLoading();
  const navigate = useNavigate();

  useEffect(() => {
    const sessionUser = JSON.parse(sessionStorage.getItem("user"));
    if (sessionUser && sessionUser.payLoad.access_token) {
      setSession(sessionUser.payLoad.user);
    }
    const redirectFromVideoCall = sessionStorage.getItem(
      "redirectFromVideoCall"
    );
    if (redirectFromVideoCall === "true") {
      Swal.fire({
        icon: "info",
        title: "Prescription",
        text: "Your prescription will be ready in 5 minutes and you can see it in the prescription tab.",
        confirmButtonText: "Ok",
      }).then(() => {
        sessionUser.package = "";
        sessionStorage.setItem("userData", JSON.stringify(sessionUser));
        sessionStorage.removeItem("redirectFromVideoCall");
      });
    }
  }, []);

  useEffect(() => {
    const realtimeRef = ref(database, "Doctors");
    const unsubscribe = onValue(realtimeRef, (snapshot) => {
      const realtimeData = snapshot.val();
      if (realtimeData) {
        const updatedDoctors = doctors.map((doctor) => {
          const email = doctor.Email.replace(/\./g, "");
          const status = realtimeData[email]?.status || doctor.status;
          return { ...doctor, status };
        });
        setDoctors(updatedDoctors);
      }
    });
    return () => {
      unsubscribe();
    };
  }, [doctors]);

  return (
    <div className="landing-page">
      {/* Header Bar */}
      {/* Removed header with Home and Sign up / Login buttons */}
      {/* Hero Section */}
      <section className="lp-hero-section img-fluid">
        {/* <div className="">
          <div className="lp-hero-overlay"></div>
          <div className="lp-hero-content ">
            <div className="d-flex align-items-center justify-content-between">
              <h1 className="lp-hero-title w-75 ">Welcome to</h1>
              <p className="lp-hero-sub w-50  mt-5">
                Your health is our priority.
                <br />
                Connect with the best doctor today!
              </p>
            </div>
            <p
              style={{ marginLeft: "10%" }}
              className="lp-hero-title-highlight"
            >
              WEBDOC Healthcare
            </p>
          </div>
        </div>
         */}
      </section>


      {/* Doctor List Section */}
      <section className="lp-doctor-list-section">
        <DoctorListComponent />
      </section>

      <Footer />
    </div>
  );
};

export default LandingPage;
